export var objectIndexFromStringArray = function (object, array) { return array.reduce(function (obj, i) { return obj[i]; }, object); };
